export default __webpack_public_path__ + "static/analytics_image-a6fbf9713415cc43d262f92e4d6a59b8.png";